import React from 'react';
import PropTypes from 'prop-types';

import CategoryPresenter from '../../presenters/CategoryPresenter';

const CategoryCheckbox = (props) => {
  const { category, categoryIds, onCategoriesUpdate } = props;

  const handleCategoriesUpdate = (values) => {
    onCategoriesUpdate('categoryIds', values);
  };

  const handleCategoryChange = ({ target }) => {
    const { id, checked } = target;
    if (checked) return handleAddCategory(id);

    return handleRemoveCategory(id);
  };

  const handleAddCategory = (id) => {
    const newCategoryIds = [...categoryIds, id];

    return handleCategoriesUpdate(newCategoryIds);
  };

  const handleRemoveCategory = (id) => {
    const newCategoryIds = categoryIds.filter(
      (categoryId) => categoryId !== id
    );

    return handleCategoriesUpdate(newCategoryIds);
  };

  const isSelected = (id) => {
    return categoryIds.includes(id);
  };

  return (
    <div>
      <label className="checkbox">
        <input
          type="checkbox"
          id={CategoryPresenter.id(category)}
          value={CategoryPresenter.id(category)}
          onChange={handleCategoryChange}
          checked={isSelected(CategoryPresenter.id(category))}
        />
        {CategoryPresenter.name(category)}
      </label>
    </div>
  );
};

export default CategoryCheckbox;

CategoryCheckbox.propTypes = {
  category: CategoryPresenter.shape().isRequired,
  categoryIds: PropTypes.arrayOf(PropTypes.string),
  onCategoriesUpdate: PropTypes.func.isRequired,
};

CategoryCheckbox.defaultProps = {
  categoryIds: [],
};
